import { InjectionToken, Provider } from '@angular/core';
import { Page } from '@nx-icilalune/data/icilalune/types';
import { ROUTE_CLIENT_ID, ROUTED_ID } from '@icilalune/router';
import { distinctUntilChanged, filter, map, Observable, switchMap } from 'rxjs';
import { DrupalEntity, DrupalNode } from '@nx-icilalune/drupal-types';
import { GetEntityPipe } from '@nx-icilalune/data/access';
import { isEqual } from '@madeinlune/ngx-operators';
import { ROUTED_ENTITY_ALTERNATIVES } from '@nx-icilalune/data/icilalune/tokens';
import { CLIENT_ID } from '@icilalune/list-feature/tokens';

export const ROUTED_CONTENT = new InjectionToken<DrupalNode>('ROUTED_CONTENT');

export const ROUTED_PAGE = new InjectionToken<Page>('ROUTED_PAGE');

export const ROUTE_PROVIDERS: Provider[] = [
  {
    provide: ROUTED_CONTENT,
    deps: [ROUTED_ID, GetEntityPipe],
    useFactory: (
      routedId$: Observable<string | undefined>,
      getEntityPipe: GetEntityPipe
    ) => {
      return routedId$.pipe(
        distinctUntilChanged(),
        switchMap((routedId) => {
          return getEntityPipe.transform<DrupalNode>(routedId);
        }),
        isEqual()
      );
    },
  },
  {
    provide: ROUTED_PAGE,
    deps: [ROUTED_CONTENT],
    useFactory: (routedContent$: Observable<DrupalEntity | undefined>) => {
      return routedContent$.pipe(
        filter((routedContent) => {
          return !!routedContent && routedContent.type === Page.type;
        })
      );
    },
  },
  {
    provide: CLIENT_ID,
    deps: [ROUTE_CLIENT_ID],
    useFactory: (clientId$: Observable<string | undefined>) => {
      return clientId$;
    },
  },
  {
    provide: ROUTED_ENTITY_ALTERNATIVES,
    deps: [ROUTED_CONTENT],
    useFactory: (routedEntity$: Observable<DrupalEntity>) => {
      return routedEntity$.pipe(
        filter((routedEntity) => !!routedEntity),
        map((routedEntity) => {
          return routedEntity.alternatives;
        })
      );
    },
  },
];
